import React, { Component } from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

class Calendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: this.props.value,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({
                date: this.props.value,
            });
        }
    }

    render() {
        const { handleCalendar } = this.props;
        const { date } = this.state;
        return (
            <>
                <DatePicker
                    selected={date}
                    onChange={handleCalendar}
                    dateFormat="yyyy/MM/dd"
                />
            </>
        );
    }
}

export default Calendar;
